import { useEffect, useState } from 'react';

const QUERY = '(orientation: landscape)';

/**
 * True on a horizontal screen. Backed by matchMedia, so it only re-renders the
 * caller when the orientation actually flips - never on resize or scroll.
 */
const useIsLandscape = (): boolean => {
  const [isLandscape, setIsLandscape] = useState<boolean>(() => window.matchMedia(QUERY).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(QUERY);
    const handleChange = (event: MediaQueryListEvent) => setIsLandscape(event.matches);

    // Older kiosk WebViews only have the deprecated addListener.
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }
    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  return isLandscape;
};

export default useIsLandscape;
